import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import type { OpalApi } from '../../schema'

export const createWorkflow: OpalApi<'CreateWorkflowsV3', 201> = async ({
  params,
  requestBody,
}: Parameters<OpalApi<'CreateWorkflowsV3', 201>>[0] = {}) => {
  const url = new URL('/v3/workflows', window.location.origin)
  url.search = queryString(params?.query)
  return HttpClient()
    .post(url.toString(), requestBody)
    .then((res) => res.data)
}
